import React, { useEffect } from "react"

import desktopLogo from "../../images/nutrafol-logo.svg"

import { queries } from "../../utils/mediaqueries"

import styled from "@emotion/styled"

import { footerIcons } from "../../data/socialmediaicons"

import EmailInput from "../emailinput"
import AdChoicesLink from "../adchoiceslink/adchoiceslink"

import { Box, Flex } from "reflexbox"

import { connect } from "react-redux"

import theme from "../../theme"

import {
  // FooterWrapper,
  NewsletterBox,
  LogoBox,
  NewsletterInner,
  LogoInner,
  NewsletterLabelBox,
  NewsletterInputBox,
  SocialLogoBox,
  FooterNotes,
} from "../styled"

const Footer = ({ searchResults, query, showModalWithMessage }) => {
  const Privacy = styled.div`
    margin-right: 0.3rem;
    margin-bottom: auto;
    line-height: 0;
    > a,
    button > span {
      font-size: 10px;
      font-family: ${theme.font.demi} !important;
      line-height: 13px;
      font-weight: 500;
      text-decoration: underline;
      color: #22202f;
    }
  `

  const FooterWrapperWrapper = styled.div`
    background: rgb(233, 225, 211);
    width: 100%;
    position: ${query !== "" && searchResults.length === 0
      ? "fixed"
      : "relative"};
    bottom: ${query !== "" && searchResults.length === 0 ? "0" : "auto"};
    ${queries.medium`
      position: ${
        query !== "" && searchResults.length < 4 ? "fixed" : "relative"
      };
      bottom: ${query !== "" && searchResults.length < 4 ? "0" : "auto"};
    `}
  `

  const FooterWrapper = styled(Flex)`
    background: rgb(233, 225, 211) !important;
    flex-direction: column;
    width: 100%;
    // max-width: 1080px;
    padding: 15px 25px;
    margin-left: auto;
    margin-right: auto;
    // position: absolute;
    // bottom: 0;
    // right: 0;
    // left: 0;
    // position: ${query !== "" && searchResults.length === 0
      ? "fixed"
      : "relative"};
    // bottom: ${query !== "" && searchResults.length === 0 ? "0" : "auto"};
    ${queries.medium`
      width: 100%;
      max-width: 1280px;
      margin-left: auto;
      margin-right: auto;
      padding-top: 30px;
      padding-bottom: 30px;
      // height: 158px;
      flex-direction: row-reverse;
    `}
  `

  useEffect(() => {
    if (typeof window !== "undefined") {
      // debugger
    }
  }, [])

  const renderIcons = () => {
    return footerIcons.map((icon) => {
      return (
        <div className="icon-item" key={`footer${icon.alt}`}>
          <a href={icon.link} target="_blank" rel="noreferrer noopener">
            <img src={icon.icon} className="social-icon" alt={icon.alt} />
          </a>
        </div>
      )
    })
  }

  return (
    <FooterWrapperWrapper>
      <FooterWrapper>
        <NewsletterBox>
          <NewsletterInner>
            <NewsletterLabelBox>
              <p>{`Sign up for the Nutrafol Newsletter`}</p>
            </NewsletterLabelBox>
            <NewsletterInputBox>
              <EmailInput
                parent="footer"
                footer={true}
                key="footer"
                showModalWithMessage={showModalWithMessage}
              />
            </NewsletterInputBox>
          </NewsletterInner>
        </NewsletterBox>
        <LogoBox>
          <LogoInner>
            <SocialLogoBox>
              <div className="logo-holder">
                <img
                  src={desktopLogo}
                  className="nutra-logo"
                  alt="Nutrafol Logo"
                />
              </div>
              <div className="social-icon-holder">{renderIcons()}</div>
            </SocialLogoBox>
            <FooterNotes>
              <p>
                {`© ${new Date().getFullYear()} Nutraceutical Wellness Inc. All Rights Reserved.`}
              </p>
            </FooterNotes>
            <FooterNotes>
              <p>
                These statements have not been evaluated by the Food and Drug
                Administration. This product is not intended to diagnose, treat,
                cure or prevent any disease.
              </p>
            </FooterNotes>
            <FooterNotes>
              <Flex flexDirection={"row"}>
                <Privacy>
                  <a href={`${process.env.GATSBY_MAGENTO_URL}privacy-policy/`}>
                    Privacy Policy
                  </a>
                </Privacy>
                <Privacy>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="/blog/sitemap-0.xml"
                  >
                    Sitemap <span className="sr-only">(Opens in new tab)</span>
                  </a>
                </Privacy>
              </Flex>
            </FooterNotes>
            <FooterNotes>
              <Flex flexDirection={"row"}>
                <Privacy>
                  <AdChoicesLink />
                </Privacy>
              </Flex>
            </FooterNotes>
          </LogoInner>
        </LogoBox>
      </FooterWrapper>
    </FooterWrapperWrapper>
  )
}

const mapStateToProps = (state) => {
  return {
    searchResults: state.searchResultsReducer.searchResults,
    query: state.queryReducer.query,
  }
}

export default connect(mapStateToProps)(Footer)
